module.exports = __webpack_public_path__ + "img/watage_3.563d1480.png";